module.exports = __webpack_public_path__ + "img/alert-triangle-black-icon.2479289d.svg";